import React from "react";
import {Form, Input} from "antd";
import ITabOptions from "../../../../../model/interface/form/elementOptions/ITabOptions";
import TranslationInput from "../../../../shared/input/TranslationInput";
import Utils from "../../../../../utils";

interface IProps {
    options: ITabOptions
}

class TabWidgetEditor extends React.Component<IProps> {


    render() {
        return (
            <Form.Item name={'label'} label={'Zvolte nazev'} rules={[{required: true}]}>
                <TranslationInput code={'configuration.widget.tab.' + Utils.uuid()} preserveCode={true}/>
            </Form.Item>
        )
    }
}

export default TabWidgetEditor